<template>
    <div class="PersonageRealName">
        <topHead>
            <img slot="head" src="../../assets/images/fh.png" alt="" @click="backBefor()" />
            <h3 slot="header">客户资料补全</h3>
        </topHead>
        <!-- 内容 -->
        <div class="main">
            <div class="ipt">
                <p>实名手机号</p>
                <input type="text" maxlength="11" placeholder="请输入手机号" oninput="value=value.replace(/[^\d]/g,'')"
                    v-model="phone" />
            </div>
            <van-button round type="info" @click="cancelHeadler">下一步</van-button>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
import topHead from "../../components/topHead.vue"
import { PersonTransAcctT } from "../../common/newapi/ghsm_api"
export default {
    components: {
        topHead
    },
    data() {
        return {
            phone: "",
        }
    },

    created() {
        this.login()
    },
    // 组件方法
    methods: {
        login() {
            let token = localStorage.getItem("token")
            if (!token) {
                this.$router.push("/PersonalInformation")
            }
        },

        // 下一步 
        async cancelHeadler() {
            let phoneVerify = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (this.phone == "") {
                Toast({
                    message: "手机号不可为空",
                    position: "bottom",
                })
            } else if (!phoneVerify.test(this.phone)) {
                Toast({
                    message: "请输入正确的手机号",
                    position: "bottom",
                })
            } else {
                let personTransAcctT = await PersonTransAcctT({
                    token: localStorage.getItem("token"),
                    phone: this.phone,
                    url: "/PersonageRealNameForm"
                })
                if (personTransAcctT.code != 1) {
                    Toast({
                        message: personTransAcctT.msg,
                        position: "bottom",
                    })
                } else {
                    sessionStorage.setItem("biz_no", personTransAcctT.data.biz_no)
                    window.location.href = personTransAcctT.data.url
                }
            }
        },

        backBefor() {
            this.$router.replace("/")
        },
    },

    computed: {},

    watch: {},

    mounted() { },
}
</script>

<style scoped lang='scss'>
.PersonageRealName {

    .header {
        height: px2rem(60);
        display: flex;
        justify-content: center;
        align-items: center;

        h3 {
            font-size: px2rem(38);
        }
    }

    .main {
        padding: 0 px2rem(30);

        .ipt {
            position: relative;
            width: 100%;
            height: px2rem(100);
            background-color: #f6f6f6;
            border-radius: px2rem(18);
            margin-top: px2rem(60);
            font-size: px2rem(26);
            padding: 0 px2rem(30);
            box-sizing: border-box;

            input {
                width: 100%;
                height: px2rem(100);
                text-align: right;
            }

            p {
                position: absolute;
                left: px2rem(30);
                top: 0;
                height: px2rem(100);
                line-height: px2rem(100);
            }
        }

        .van-button {
            display: flex;
            justify-content: center;
            text-align: center;
            width: px2rem(550);
            height: px2rem(80);
            line-height: px2rem(80);
            color: #fff;
            font-weight: bold;
            font-size: px2rem(28);
            background-color: #336289;
            margin: px2rem(240) auto 0;
            box-shadow: 0 0 px2rem(10) rgba($color: #000000, $alpha: 0.2);
        }
    }

}
</style>